import React, { useEffect, useRef, useState } from "react";
import "./mm.css";
import { EmailGate } from "./components/mm/EmailGate";
import { ProgressBar, StepNav, useRevealAll } from "./components/mm/Nav";
import { Hero, Intro } from "./components/mm/Sections";
import { StepManifest, StepFeel } from "./components/mm/StepsA";
import { StepBecome, StepFear, StepAppreciate } from "./components/mm/StepsB";
import { Protocol } from "./components/mm/Protocol";
import { Closing, Mark } from "./components/mm/Closing";
import { FuturePopup } from "./components/mm/FuturePopup";
import { saveProtocol } from "./components/mm/lib";
import AdminPage from "./components/mm/AdminPage";

const INITIAL = {
  stage: 1, manifestText: "", three: ["", "", ""], desires: [], identityText: "", becomeAnswers: {}, identity: "", groups: [],
  fearText: "", fears: [], fearClarify: "", fearClarifyAnswer: "", scheduled: null, glimmers: {}, whereText: "", howText: "",
};

const usePersisted = (key, initial) => {
  const [v, setV] = useState(() => {
    const s = localStorage.getItem(key);
    return s ? { ...initial, ...JSON.parse(s) } : initial;
  });
  useEffect(() => localStorage.setItem(key, JSON.stringify(v)), [key, v]);
  return [v, setV];
};

function App() {
  const [email, setEmail] = useState(() => localStorage.getItem("mmVisitorEmail") || "");
  const [p, setP] = usePersisted("mmMethod", INITIAL);
  const scrollTo = useRef(null);
  useRevealAll();

  useEffect(() => {
    document.body.classList.toggle("gate-active", !email);
  }, [email]);

  useEffect(() => {
    if (!scrollTo.current) return;
    const id = scrollTo.current;
    scrollTo.current = null;
    setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
  }, [p.stage]);

  const update = (patch) => setP((cur) => ({ ...cur, ...patch }));
  const go = (n) => {
    const id = n > 5 ? "protocol" : `step-${n}`;
    if (n > p.stage) {
      scrollTo.current = id;
      setP((cur) => ({ ...cur, stage: n }));
    } else {
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
    }
  };
  const reveal = () => {
    saveProtocol(email, { ...p, stage: 6 }).catch((e) => console.error(e));
    go(6);
  };
  const restart = () => {
    setP(INITIAL);
    setTimeout(() => document.getElementById("step-1")?.scrollIntoView({ behavior: "smooth" }), 80);
  };
  const onUnlock = (v) => {
    localStorage.setItem("mmVisitorEmail", v);
    setEmail(v);
  };

  const props = { p, update, go };
  return (
    <div className="mm">
      <EmailGate open={!email} onUnlock={onUnlock} />
      <ProgressBar />
      <StepNav stage={p.stage} />
      <Hero />
      <Intro />
      <StepManifest {...props} />
      {p.stage >= 2 && <StepFeel {...props} />}
      {p.stage >= 3 && <StepBecome {...props} />}
      {p.stage >= 4 && <StepAppreciate {...props} />}
      {p.stage >= 5 && <StepFear {...props} onReveal={reveal} />}
      {p.stage >= 6 && <Protocol p={p} email={email} onRestart={restart} />}
      {p.stage >= 6 && <Closing />}
      {p.stage >= 6 && <FuturePopup />}
      <Mark />
    </div>
  );
}

const Root = () => (window.location.pathname.startsWith("/admin") ? <AdminPage /> : <App />);

export default Root;
